import React, { useCallback, useEffect, useRef, useState } from "react";
import "./ViewAndEdit.css";
import { GenericTable } from "../../components/genericTable/GenericTable";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import UserModal from "../../components/userModal/UserModal";
import {
  donwloadReportWithStatus,
  downloadMasterDataReport,
  getAdditionalData,
  getAllEntityMetaData,
  resetPassword,
  resetStatus,
} from "../../services/userService";
import { Loader } from "../../components/loader/Loader";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { popupType } from "../../types/types";
import { Box, Modal, Pagination } from "@mui/material";
import { outletMetaData, searchPropsType, updateType } from "./ViewAndEditType";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import { Entities, EntityVeiwMapping } from "../../configurations/ViewAndEdit";
import { modelDataType } from "../../components/userModal/userModalType";
import store from "../../stateManagement/store";
import { useNavigate } from "react-router-dom";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import ProductModal from "../../components/productModal/ProductModal";
import { ColumnHeader, ModifiedData, productMetaData } from "../../components/productModal/ProductModalTypes";
import OutletModal from "../../components/ouletModal/OutletModal";
import { useSelector } from "react-redux";
import BackButton from "../../components/Buttons/BackButton/BackButton";
import WDModal from "../../components/userModal/WDModal";
import { getMetaDataConfig } from "../../services/uiConfigService";
import GenericViewAndEditModal from "../../components/ouletModal/GenericViewAndEditModal";
import { MDMModalConfig, Tab } from "../../components/ouletModal/OutletModalTypes";
import DownloadLoader from "../../components/popup/downloadLoader";
import GenericFilters from "../../components/genericFilters/genericFilters";
import { getCurrentGlobalFilterObject } from "../../stateManagement/actions/genericFilterActions";
import { genericFilterType } from "../../stateManagement/reducers/genericFilterReducer";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { getAccessToken } from "../../services/authenticationService";

import { fetchAndDownloadReport } from "../../services/reportService";
import PSRModal from "../../components/userModal/PSRModal";
import { configurationAttributeType } from "../../types";

export const ViewAndEdit = () => {
  const mdmState = useSelector(() => store.getState().mdmReducer)
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const entity = mdmState?.entity as Entities;
  const { tableHeaders, modalConfig, exportConfig,searchEnabledColumnsConfig,userNameKey,disableEdit,getDataConfig } = mdmState;
  const navigate = useNavigate();
  const designation = mdmState.designation;
  const mdmId = mdmState.id;
  const configuration = EntityVeiwMapping.filter((viewEntityMetaData) => {
    return entity === viewEntityMetaData.entity;
  });
  const [columnHeaders, setColumnHeaders] = useState<ColumnHeader[]>(configuration.length > 0 ? configuration[0].columns : []);
  const [activeDisabled, setactiveDisabled] = useState<String>("")
  const endPoint = getDataConfig && getDataConfig.api
  ? getDataConfig.api
  : configuration.length 
    ? configuration[0].endPoint.getAllData
    : "";
  const [genericModal, setGenericModal] = useState<Boolean>(false);
  const [mdmModalConfig, setMDMModalConfig] = useState<Tab[]>([]);
  const [openReportModal, setOpenReportModal] = useState<boolean>(false);
  const [resetFiltersFlag,setResetFiltersFlag] = useState<boolean>(false);
  const [outletCodeInitial, setOutletCodeInitial] = useState<string>("");

  const modifiedData = {
    ...configuration[0],
    columns: columnHeaders,
    ...(tableHeaders && tableHeaders?.Actions ? { Actions: tableHeaders?.Actions } : configuration[0]?.Actions),//actions for removing view and edit section
    ...(activeDisabled ? { active: activeDisabled } : {}),
  } as ModifiedData;

  useEffect(() => {
    if (!entity) {
      navigate("/dashboard/mdm");
      return;
    }
     const fetchPortalConfig = async () => {
          const portalConfig = await getMetaDataConfig(
            "clientconfig",
            "portal_configuration"
          );
          const portal_config: configurationAttributeType[] =
            portalConfig?.domainValues ?? [];
          const disableOutletCodeInitials = portal_config?.find(
            (item) => item.name === "disableOutletCodeInitials"
          )?.value ?? ""; 
          setOutletCodeInitial(disableOutletCodeInitials);  
        };
        fetchPortalConfig();
    if (mdmId === "wdViewAndEdit" || mdmId === "OutletDetails" || mdmId === "ProductDetails" || mdmId === "brandProductMaster") {
      if (tableHeaders) {
        if(tableHeaders.columns){
          setColumnHeaders(tableHeaders.columns);
        }
        if(tableHeaders.active){
          setactiveDisabled(tableHeaders.active);
        }
      }
      if (modalConfig) {
        setGenericModal(true)
        setMDMModalConfig(modalConfig)
      }
    }
    getTableRows(endPoint, undefined, undefined, undefined, designation);

    const end = configuration[0].endPoint as Record<string, string | undefined>;

    const additionalCachedData = async () => {
      if (configuration[0] && configuration[0].additinalData) {
        return await Promise.all(
          configuration[0].additinalData.map(async (currentValue) => {
            const response = await getAdditionalData(end[currentValue]);

            return response.data.features
              ? response.data.features
              : response.data;
          })
        );
      }
    };
    const getPreRequireddata = async () => {
      const preRequiredData = await additionalCachedData();
      setAdditionalCached(preRequiredData);
    };
    getPreRequireddata();
  }, []);

  const [loader, setLoader] = useState(true);

  const [openModal, toggleModal] = useState(false);

  const [modelData, setModelData] = useState<
    modelDataType | productMetaData | outletMetaData
  >();

  const [rows, setRows] = useState([]);

  const [pages, setPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);

  const [searchedValue, setSeacrhedvalue] = useState("");

  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);

  const [additionalCached, setAdditionalCached] = useState<any[] | undefined>([]);

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);

  const [popUpMessage, setPopUpMessage] = useState<string>("");

  const popUpSuccessMethod = useRef<() => void>();

  const mdmFiltersRef = useRef<genericFilterType>({})

  const onApplyClick = async ()=>{
    setLoader(true);
    setSeacrhedvalue("");
    const globalFilterValues = store.getState()?.genericFilter;
    mdmFiltersRef.current = globalFilterValues;
    getTableRows(endPoint,1,undefined,undefined,designation,globalFilterValues);
  }
  const lastApiCallTime = useRef<number>(0);

  const getTableRows = async (
    endPoint: string,
    currentPage: number = 1,
    searchedValue?: string,
    searchedColums?: string[],
    designation?: string,
    globalFilters?: genericFilterType
  ) => {
    try {
      const currApiCallTime = Date.now();
      setLoader(true);
      if(currApiCallTime >= lastApiCallTime.current){
        lastApiCallTime.current = currApiCallTime;
    }
    const response = await getAllEntityMetaData(
      endPoint,
      currentPage - 1,
      searchedValue,
      searchedColums,
      designation,
      globalFilters,
      getDataConfig
    );
    if(currApiCallTime >= lastApiCallTime.current){
      setRows(response?.data?.features);
      setPages(response?.data?.totalPage);
    }
    if(currApiCallTime === lastApiCallTime.current){
      setLoader(false);
    }
    } catch (error) {
      setGenericMetaData(
        "Something went wrong",
        "Error",
        true
      );
      setRows([]);
      setLoader(false);
    }

  };
  const debouncingTheSearch = useCallback(
    (value: string) => {
      // debouncing code
      if (timerId) {
        clearTimeout(timerId);
      }
      const newTimerId = setTimeout(() => {
        setLoader(true);
        setCurrentPage(1);
        getTableRows(endPoint, 1, value, searchedColumns, designation,mdmFiltersRef.current);
      }, 400); // debounce time in milliseconds
      setTimerId(newTimerId);
    },
    [searchedValue, timerId]
  );

  const Actions = configuration?.length ? modifiedData.Actions : [];
  const searchedColumns =  searchEnabledColumnsConfig ?
  searchEnabledColumnsConfig
   : configuration.length
    ? modifiedData.searchEnabledColumns
    : [];
  const columns: GridColDef[] = configuration.length
    ? modifiedData.columns.map((columnsMetaData) => {
      return {
        disableColumnMenu: true,
        field: columnsMetaData.mappedValue,
        headerName: translate(entity,columnsMetaData.headerName).toUpperCase(),
        sortable: false,
        minWidth: 100,
        flex: 1,
        headerAlign: "center",
        align: "center",
        valueGetter: (params: GridRenderCellParams) => {
          if (columnsMetaData.findIn) {
            if (params.field === 'portalAccess') {
              const isAdmin = params.row.roles.find((role: { name: string; }) => role.name === "ROLE_LOGIN_ACCESS") !== undefined;
              if (isAdmin) {
                return "Y"
              } else {
                return "N"
              }
            }
            if (params.field === 'wdDistrict') {
              const metaFindIn = columnsMetaData.findIn
              var DL = params.row[metaFindIn].split(">");
              if (DL[1]) {
                return DL[1]
              }
            }
            if (params.field === 'wdBranch') {
              const metaFindIn = columnsMetaData.findIn
              var DL = params.row[metaFindIn].split(">");
              if (DL[0]) {
                return DL[0]
              }
            }
          }
          const field = params.field;
          let columnValue: any;
          if (field.includes(".")) {
            const filedArrays = field.split(".");
            columnValue = params.row;
            filedArrays?.forEach((subStringpart: string) => {
              if (!columnValue) {
                return;
              }
              columnValue = columnValue[subStringpart];
            });
            return columnValue;
          }
          if (params.field === 'discontinuedSku') {
            if (params.row.activeStatus==="active") {
              return "N"
            } else {
              return "Y"
            }
          }

          return params.row[field];
        },
      };
    })
    : [];
  function resetStatusEditBody(
    modelData: modelDataType | productMetaData | outletMetaData
  ) {
    switch (entity) {
      case "User": {
        const changeDataType = modelData as modelDataType;
        const dataObj: updateType = {
          loginId: changeDataType?.loginId,
          userAccountId: changeDataType?.userAccountId,
          activeStatus:
            modelData.activeStatus === "active" ? "inactive" : "active",
        };
        return dataObj;
      }
      case "ProductDetails": {
        const changeDataType = modelData as productMetaData;
        const dataObj: productMetaData = {
          ...changeDataType,
          activeStatus:
            changeDataType.activeStatus === "active" ? "inactive" : "active",
        };
        return dataObj;
      }
      case "OutletDetails": {
        modelData = modelData as outletMetaData;
        const dataObj: outletMetaData = {
          outletCode: modelData.outletCode,
          activeStatus:
            modelData.activeStatus === "active" ? "inactive" : "active",
          activeStatusReason:
            modelData.activeStatus +
            " by " +
            JSON.parse(localStorage.authContext).user.loginId,
            ...(userNameKey && {
              userName:{
                loginId:modelData.userName,
                activeStatus:
            modelData.activeStatus === "active" ? "inactive" : "active",
            }
            })
        };
        return dataObj;
      }
    }
  }

  const generateMesaage = (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    switch (entity) {
      case "User": {
        const changeDataType = modelData as modelDataType;
        return changeDataType.name;
      }
      case "ProductDetails": {
        const changeDataType = modelData as productMetaData;
        return changeDataType.skuDescription;
      }

      case "OutletDetails": {
        const changeDataType = modelData as outletMetaData;
        return changeDataType.outletCode;
      }
    }
  };

  const setGenericMetaData = (
    message: string,
    type: popupType,
    state: boolean
  ) => {
    setGenericModalState(state);
    setGenericModalSMessage(message);
    setGenericModalType(type);
  };

  const updateConfirmationPopData = (
    message: string,
    methodHelper: () => void
  ) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  const setPasswordToDefault = async (modelData: modelDataType | undefined) => {
    try {
      if (modelData && modelData.loginId) {
        const response = await resetPassword(modelData.loginId);
        if (response.status === 200) {
          setGenericMetaData(translate(TranslationEnum.common_portal,"Successfully updated password"), "Success", true);
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error occured while Updating the password",
        "Error",
        true
      );
    }
  };

  const changeStatusFunction = async (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    try {
      switch (entity) {
        case "User": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus("/users", requestBody);
          return response;
        }
        case "ProductDetails": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus("/products", requestBody);
          return response;
        }
        case "OutletDetails": {
          const requestBody = resetStatusEditBody(modelData);
          const response = await resetStatus(
            "/outletDetails/update",
            requestBody
          );
          return response;
        }
      }
    } catch (error) {
      return error;
    }
  };

  const updateStatus = async (
    modelData: modelDataType | productMetaData | outletMetaData
  ) => {
    try {
      if (modelData) {
        const response = await changeStatusFunction(modelData);
        if (response.status === 200 || response.status === 201) {
          setGenericMetaData("Data Updated Successfully", "Success", true);
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error occured while Updating the Status",
        "Error",
        true
      );
    }
  };

  if (Actions.includes("Product Image")) {
    columns.push({
      field: "productImage",
      headerName: "Product Image",
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.blobKey ? (
          <img src={params.row.blobKey} alt="" style={{ height: 50 }} />
        ) : (
          <p>{translate(TranslationEnum.common_portal,"No Image")}</p>
        );
      },
    });
  }

  if (Actions.includes("Image File")) {
    columns.push({
      field: "imageFile",
      headerName: "Image File",
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.blobKey ? (
          <img src={params.row.blobKey} alt="" style={{ height: 50 }} />
        ) : (
          <p>No Image</p>
        );
      },
    });
  }


  if (Actions.includes("Edit")) {
    columns.push({
      field: "Edit",
      headerName: translate(TranslationEnum.common_portal,"Edit").toUpperCase(),
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        const isDisabled = outletCodeInitial !== "" &&
          params.row.outletCode?.toLowerCase().startsWith(outletCodeInitial.toLowerCase());
        return (
          <div
            className={`edit-button ${isDisabled ? "disabled-button" : ""}`}
            onClick={() => {
              if (isDisabled) return;
              setModelData(params.row);
              toggleModal(true);
            }}
          >
            <RenderSvg name="Reset-password" />
            <span className="edit-button-text">{translate(TranslationEnum.common_portal,"Edit")}</span>
          </div>
        );
      },
    });
  }

  if (Actions.includes("ChangeStatus")) {
    columns.push({
      field: "Change Status",
      headerName: translate(TranslationEnum.common_portal,"Change Status").toUpperCase(),
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        const isDisabled = outletCodeInitial !== "" &&
          params.row.outletCode?.toLowerCase().startsWith(outletCodeInitial.toLowerCase());
        if (params.row.activeStatus === "active") {
          return (
            <div
              className={`edit-button ${isDisabled ? "disabled-button" : ""}`}
              onClick={() => {
                if (isDisabled) return;
                setModelData(params.row);
                setConfirmationPopUp(true);
                updateConfirmationPopData(
                  translate(TranslationEnum.common_portal, "Are you sure want to Deactivate {name}",{"name":generateMesaage(params.row)??""}),
                  () => {
                    updateStatus(params.row);
                  }
                );
              }}
            >
              <RenderSvg name="Deactivate" />
              <span className="edit-button-text">{translate(TranslationEnum.common_portal,"Deactivate")}</span>
            </div>
          );
        } else {
          return (
            <div
              className={`edit-button ${modifiedData.active === "disabled" ? "active-disabled" : ""} ${isDisabled ? "disabled-button" : ""}`}
              onClick={() => {
                if (isDisabled) return;
                setModelData(params.row);
                setConfirmationPopUp(true);
                updateConfirmationPopData(
                  translate(TranslationEnum.common_portal, "Are you sure want to Activate {name}",{"name":generateMesaage(params.row)??""}),
                  () => {
                    updateStatus(params.row);
                  }
                );
              }}
            >
              <RenderSvg name="Activate" />
              <span className="edit-button-text">{translate(TranslationEnum.common_portal,"Activate")}</span>
            </div>
          );
        }
      },
    });
  }
  if (Actions.includes("ResetPassword")) {
    columns.push({
      field: "Reset Password",
      headerName: translate(TranslationEnum.common_portal,"Reset Password").toUpperCase(),
      sortable: false,
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div
            className="edit-button"
            onClick={() => {
              setModelData(params.row);
              setConfirmationPopUp(true);
              updateConfirmationPopData(
                translate(TranslationEnum.common_portal, "Are you sure want to reset password for {name}",{"name":generateMesaage(params.row)??""}),
                () => {
                  setPasswordToDefault(params.row);
                }
              );
            }}
          >
            <RenderSvg name="Reset-password" />
            <span className="edit-button-text">{translate(TranslationEnum.common_portal,"Reset Password")}</span>
          </div>
        );
      },
    });
  }

  const exportFunctionalityOFMDM = async () => {
    setOpenReportModal(true)
    const response = await downloadMasterDataReport(entity, exportConfig,mdmFiltersRef.current);
    if (response.status === 200) {
      console.log(openReportModal)
      if(exportConfig){
        donwloadReportWithStatus(response.data.id,setOpenReportModal);
      }
      else{
        const data = response.data.features;
        if (data && data.length > 0) {
          await fetchAndDownloadReport(data?.[0]?.payload?.url);
          setOpenReportModal(false);
        } else {
          setGenericMetaData(
            "Looks like master data report has not been generated yet",
            "Error",
            true
          );
          setOpenReportModal(false);
        }
      } 
    } else {
      setOpenReportModal(false);
      setGenericMetaData(
        "Some Error occured while downloading the master report",
        "Error",
        true
      );
    }
  };

  const downloadURI = (Url: string, entityName: string) => {
    const a = document.createElement("a");
    a.download = entityName;
    a.href = Url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const searchProps: searchPropsType[] =
    configuration.length !== 0
      ? configuration[0].columns.map((columnsMetaData) => {
        return {
          searchKey: columnsMetaData.mappedValue,
          searchFilter: (a: string, b: string) => {
            return a === b;
          },
        };
      })
      : [];
  const loadModel = (entity: string, id?: string) => {
    switch (entity) {
      case "User":
        if (id === "wdViewAndEdit") {
          return (
            <WDModal
              close={() => toggleModal(false)}
              modelData={modelData as modelDataType}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
            />
          );
        }else if(id === "Psr"){
          return (
            <PSRModal
              close={() => toggleModal(false)}
              modelData={modelData as modelDataType}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
            />
          );
        } else {
          return (
            <UserModal
              disableEdit={disableEdit} 
              close={() => toggleModal(false)}
              modelData={modelData as modelDataType}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
            />
          );
        }
      case "ProductDetails":
        if (genericModal) {
          return (
            <GenericViewAndEditModal
              close={() => toggleModal(false)}
              modelData={modelData as outletMetaData}
              setGenericMetaData={setGenericMetaData}
              mdmModalConfig={mdmModalConfig}
              productType={true}
            />
          );
        } else {
          return (
            <ProductModal
            disableEdit={disableEdit} 
              close={() => {
                toggleModal(false);
              }}
              modelData={modelData as productMetaData}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
              additionaCachedData={additionalCached}
            />
          );
        }
      case "OutletDetails":
        if (genericModal) {
          return (
            <GenericViewAndEditModal
              close={() => toggleModal(false)}
              modelData={modelData as outletMetaData}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
              mdmModalConfig={mdmModalConfig}
            />
          );
        } else {
          return (
            <OutletModal
              disableEdit={disableEdit} 
              close={() => toggleModal(false)}
              modelData={modelData as outletMetaData}
              setGenericMetaData={setGenericMetaData}
              getTableRows={getTableRows}
              additionaCachedData={additionalCached}
            />
          );
        }
    }
  };
  return (
    <>
      {mdmState.globalFilters?.length &&  (
        <Box className="generic-filter-container">
          <GenericFilters resetFiltersFlag={resetFiltersFlag} onApplyClick={onApplyClick} filterOptions={mdmState.globalFilters}  />
        </Box>
      )}
      <div className="content">
        <div className="edit-header-container">
          <div className="edit-icon-container"><RenderSvg name="Edit-icon-black" /></div>
          <span className="content-text">{translate(TranslationEnum.common_portal,"Edit a record")}</span>
        </div>
        <span
          className="export-button"
          onClick={() => {
            setConfirmationPopUp(true);
            updateConfirmationPopData(
              "Are you sure you want to download master data?",
              () => {
                exportFunctionalityOFMDM();
              }
            );
          }}
        >
       {translate(TranslationEnum.common_portal,"Export")}
          <RenderSvg name="Export-icon" />
        </span>
        <div className="edit-search-back-btn">
          <div className="search-field">
            <input
              type="text"
              placeholder={translate(TranslationEnum.common_portal,"Search")}
              name="search"
              autoFocus
              className="search-input-field"
              value={searchedValue}
              onChange={(e) => {
                setSeacrhedvalue(e.target.value);
                debouncingTheSearch(e.target.value);
              }}
            />
          </div>
          <BackButton />
        </div>
      </div>
      <Modal
        style={{ zIndex: 100 }}
        open={openModal}
        onClose={() => {
          toggleModal(false);
        }}
      >
        <>{loadModel(entity, mdmId)}</>
      </Modal>

      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />

      <GenericPopUp
        type={genericModaltype}
        message={genericModalMessage}
        openGenericModal={genericModalState}
        setOpenGenericModal={() => {
          genericModaltype === 'Success' && getTableRows(endPoint, currentPage, undefined, undefined, designation);
          setResetFiltersFlag(!resetFiltersFlag);
          mdmFiltersRef.current = {};
          setGenericModalState(false);
        }}
      />
      {loader ? (
        <Loader />
      ) : (
        <div className="table-style">
          <GenericTable
            searchedProps={searchProps}
            table={{
              rows,
              columns,
              isOfflineSearchEnable: false,
              hideFooter: true,
            }}
          />
          <div className="pagination">
            <Pagination
              count={pages}
              variant="outlined"
              shape="rounded"
              color={"primary"}
              onChange={async (event, value) => {
                setCurrentPage(value);
                setLoader(true);
                await getTableRows(endPoint, value, searchedValue, searchedColumns, designation,mdmFiltersRef.current);
              }}
              page={currentPage}
            />
          </div>
          {openReportModal ? (
            <DownloadLoader
              message={"Your report will be downloaded shortly."}
              openReportModal={openReportModal}
              setOpenReportModal={setOpenReportModal}
            />
          ) : null}
        </div>
      )}
    </>
  );
};
